import React, { createContext, useContext, useState } from 'react';

const MessageContext = createContext(undefined);

export const useMessage = () => {
  const context = useContext(MessageContext);
  if (!context) {
    throw new Error('useMessage must be used within a MessageProvider');
  }
  return context;
};

export const MessageProvider = ({ children }) => {
  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState(null);

  const showMessage = (type, text) => {
    setMessageType(type);
    setMessage(text);
  };

  const dismissMessage = () => {
    setMessage(null);
    setMessageType(null);
  };

  return (
    <MessageContext.Provider value={{ message, messageType, showMessage, dismissMessage }}>
      {children}
    </MessageContext.Provider>
  );
};
